import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowUpLeftCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 2c-3.17 0-5.715.793-7.461 2.539S2 8.829 2 12c0 3.17.793 5.715 2.539 7.461S8.829 22 12 22c3.17 0 5.715-.793 7.461-2.539S22 15.171 22 12c0-3.17-.793-5.715-2.539-7.461S15.171 2 12 2m3.707 12.293a1 1 0 0 1-1.414 1.414l-3.043-3.043-1.543 1.543A1 1 0 0 1 8 13.5V9a1 1 0 0 1 1-1h4.5a1 1 0 0 1 .707 1.707l-1.543 1.543z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowUpLeftCircle)
export default ForwardRef
